import { CSSObject } from '@chakra-ui/react';

export const RaceMeetingsList: CSSObject = {
  px: '0',
  borderBottomRadius: '7px',
};

export const BoxWrapper: CSSObject = {};
